import {doc, increment, setDoc, updateDoc} from "firebase/firestore";
import {fire} from "../../fire";

export const registrarSustraerProducto = async ({producto, coleccion = 'metricasGlobales', metrica = 'cantidad'}) => {

    let referencia = doc(fire, coleccion, producto.id)

    try {
        await updateDoc(referencia, {
            [metrica]: increment(-1)
        });
    } catch (err) {

        try {
            await updateDoc(referencia, {[metrica]: 0});
        } catch (err) {
            await setDoc(referencia, {...producto, cantidad: 0});
        }

    }

}